import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
  page404: {
    margin: [0, 'auto'],
    maxWidth: '64rem',
    marginTop: '1.25rem',
  },

  errorNumber: {
    lineHeight: 1,
    fontWeight: 300,
    fontSize: '6.25rem',
    margin: [0, 0, '1rem'],
  },

  title: {
    fontSize: '1.75rem',
    fontWeight: 'normal',
    margin: [0, 0, '1rem'],
  },

  homeButton: {
    marginTop: '1.5625rem',
  },
})
